// Module
var code = "<h2 id=\"account-access\">Account Access</h2> <p>Manage your student loans online anytime. It&#39;s quick and secure.</p> ";
// Exports
export default code;